<template>
<div class="container full-height full-width">
  <div class="flex container column center-center white">
    <div class="fix-login">
      <div class="text-center">
        <!-- <img src="../../assets/img/logo2.svg" width="150" alt="Minds"> -->
      </div>

      <div class="flex">
        <form role="form" method="POST" action="" class="full-width" @submit.prevent="validateBeforeSubmit">

          <div class="area-login" :class="{'has-danger': errors.has('name') }">
            <label for="">Nome</label>
            <div>
              <input type="text" class="input-style" name="name" v-validate="'required'" required autofocus v-model="form.name" data-vv-as="nome">
            </div>
            <div v-show="errors.has('name')">
              <span class="help-block color-danger">
                  <small>{{ errors.first('name') }}</small>
                </span>
            </div>

          </div>
          <div class="area-login" :class="{'has-danger': errors.has('email') }">
            <label for="">E-mail</label>
            <div>
              <input type="email" class="input-style" name="email" v-validate="'required|email'" required autofocus v-model="form.email">
            </div>
            <div v-show="errors.has('email')">
              <span class="help-block color-danger">
                  <small>{{ errors.first('email') }}</small>
                </span>
            </div>

          </div>

          <div class="area-login" :class="{'has-danger': errors.has('password') }">
            <label for="">Senha</label>
            <div class="">
              <input class="input-style" type="password" v-validate="'required'" name="password" required v-model="form.password" data-vv-as="senha">
            </div>
            <div v-show="errors.has('password')">
              <span class="help-block color-danger">
                  <small>{{ errors.first('password') }}</small>
                </span>
            </div>
          </div>
          <div class="area-login">
            <label for="password-confirm">Confirmar senha </label>

            <div>
              <input class="input-style" id="password-confirm" type="password" name="password_confirmation" required v-validate="'required|confirmed:password'" data-vv-as="confirmação de senha" v-model="form.password_confirmation">
            </div>
            <div v-show="errors.has('password_confirmation')">
              <span class="help-block color-danger">
                  <small>{{ errors.first('password_confirmation') }}</small>
                </span>
            </div>
          </div>


          <div class="area-login full-width">
            <button type="submit" class="full-width" :disabled="isLoading">Cadastrar <i v-show="isLoading"
                                                                                          class="fa fa-spinner fa-spin"></i>
              </button>
          </div>

          <!--<ui-alert @dismiss="formError = false" type="error" v-show="formError">-->
          <!--<p v-for="error in formError">{{error[0]}}</p>-->
          <!--</ui-alert>-->

          <div class="area-login text-center">
            <router-link :to="{ name: 'login' }">Já tenho conta</router-link>
          </div>
        </form>

        <div class="area-login text-center inv-some">
          <div class="text-center">
            Já tem sua conta?
            <br/>
            <router-link :to="{ name: 'login' }">Login</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="basis5 full container center-center column some">
    <div class="img-full">
      <div class="txt-full container center-center" style="height: 100%">
        <div class="text text-center">
          Já tem sua conta?
          <br/>
          <router-link :to="{ name: 'login' }">Login</router-link>

        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      formError: null,
      form: {
        name: '',
        email: '',
        password: '',
        password_confirmation: ''
      },
      isLoading: false
    }
  },
  // beforeCreate() {
  //   if (this.$store.state.auth.isLoggedIn) {
  //     this.$router.push({
  //       name: 'home'
  //     })
  //   }
  // },
  methods: {
    validateBeforeSubmit(e) {
      this.isLoading = true
      this.$validator.validateAll().then(x => {
        // authService.signup(this.form).then(user => {
        //   this.$router.replace({
        //     name: 'home'
        //   })
        // }).catch(error => {
        //   var errors = error.response.data.errors
        //   var msg = []
        //   forEach(errors, function(value, key) {
        //     msg += value[0]
        //   })
        //
        //   this.$notify.error({
        //     message: msg,
        //     title: 'Oppps!! Algo deu errado'
        //   })
        //
        //   this.isLoading = false
        // })
      }).catch(e => {
        alert(e)
      })
    }
  }
}
</script>

<style lang="scss">
@import "./src/assets/css/components/login.scss";
</style>



// WEBPACK FOOTER //
// src/pages/auth/register.vue